import React, { useState, useEffect } from 'react';

const FunFact = ({ data }) => {
    const { contentName, contentNumber, plus, img } = data;
    const [count, setCount] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const targetNumber = parseInt(contentNumber, 10);
    
    // Function to format numbers with commas
    const formatNumberWithCommas = (num) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    useEffect(() => {
        // Check if element is in viewport using Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(true);
            }
        }, { threshold: 0.1 });

        const element = document.getElementById(`funfact-${data.id}`);
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, [data.id]);

    useEffect(() => {
        // Animate the counter when element becomes visible
        if (!isVisible) return;

        // Don't animate if targetNumber is not a valid number
        if (isNaN(targetNumber)) {
            setCount(0);
            return;
        }

        let start = 0;
        const duration = 2000; // 2 seconds
        const step = Math.max(1, Math.floor(targetNumber / (duration / 16))); // 16ms per frame (approx 60fps)
        
        const timer = setInterval(() => {
            start += step;
            if (start > targetNumber) {
                setCount(targetNumber);
                clearInterval(timer);
            } else {
                setCount(start);
            }
        }, 16);

        return () => clearInterval(timer);
    }, [isVisible, targetNumber]);

    return (
        <div id={`funfact-${data.id}`} className="funfact2 d-flex align-items-center">
            <div className="fun_img">
                <img src={img} alt={contentName} loading="lazy" />
            </div>
            <div className="funfact_content">
                <p>{contentName}</p>
                <div className="d-flex align-items-center">
                    <h2 className="fun-number">{isNaN(targetNumber) ? contentNumber : formatNumberWithCommas(count)}</h2>
                    <span>{plus}</span>
                </div>
            </div>
        </div>
    );
};

export default FunFact;
